export const jsonCustomAbiertas = [
  {
    tipo: 1,
    nombre: 'textarea',
    json: {
      answers: [
        {
          type: 2,
          isTextArea: true,
          isOnlyNumeric: false,
          length: 500
        }
      ]
    }
  },
  {
    tipo: 2,
    nombre: 'inputNumerico',
    json: {
      answers: [
        {
          type: 2,
          isTextArea: false,
          isOnlyNumeric: true,
          length: 500
        }
      ]
    }
  },
];
